import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  margin-bottom: 40px;
  @media screen and (max-width: 480px) {
    margin-bottom: 20px;
  }
`;
export const Left = styled.div`
  width: 50%;
  height: 80vh;
  -webkit-clip-path: polygon(0 0, 100% 0, 70% 100%, 0% 100%);
  clip-path: polygon(0 0, 100% 0, 70% 100%, 0% 100%);
  @media screen and (max-width: 480px) {
    height: 380px;
    -webkit-clip-path: polygon(0 0, 100% 0, 53% 100%, 0% 100%);
    clip-path: polygon(0 0, 100% 0, 53% 100%, 0% 100%);
  }
`;
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  width: 45%;
  @media screen and (max-width: 480px) {
    width: 50%;
    position: relative;
  }
`;
export const Info = styled.div`
  width: 80%;
  @media screen and (max-width: 480px) {
    width: 105%;
    position: absolute;
    left: -19px;
    top: 105px;
  }
`;
export const Name = styled.p`
  font-size: 45px;
  margin-bottom: 30px;
  @media screen and (max-width: 480px) {
    font-size: 22px;
    margin-bottom: 15px;
    font-weight: 500;
  }
`;
export const Desc = styled.p`
  font-size: 16px;
  margin-bottom: 30px;
  text-align: justify;
  text-justify: inter-word;
  font-weight: 300;
  @media screen and (max-width: 480px) {
    font-size: 11px;
    margin-bottom: 15px;
    font-weight: 500;
  }
`;
export const Contact = styled.button`
  border: none;
  background: #2f3133;
  color: white;
  height: 36px;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 480px) {
    height: 28px;
    width: 70px;
    font-size: 11px;
  }
`;
